<template>
  <el-table-column
    prop="tax_number"
    sortable="custom"
    label="Adószám"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.company.tax_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'tax_number',
};
</script>
